import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconSwedenComponent = ({ ...rest }) => {
  return (
    <SvgIcon {...rest}>
      <svg
        fill="none"
        height="60"
        viewBox="0 0 80 60"
        width="80"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3012_1348)">
          <path d="M0 0H80V60H0V0Z" fill="#005293" />
          <path d="M22 0V24H0V36H22V60H34V36H80V24H34V0H22Z" fill="#FECB00" />
        </g>
        <defs>
          <clipPath id="clip0_3012_1348">
            <rect fill="white" height="60" rx="8" width="80" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

IconSwedenComponent.displayName = 'IconSweden';

const IconSweden = memo(IconSwedenComponent);

export default IconSweden;
